'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useRef, useState } from 'react';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import cx from 'classnames';
import { usePathname } from 'next/navigation';

import Logo from 'components/globals/Logo';

import Link from 'components/ui/Link';
import EntryLink from 'components/ui/Link/EntryLink';

import CheeseburgerButton from './CheeseburgerButton';
import { SubNavGroupItems, SubNavItems } from './SubNavItems';

import SearchBar from '../SearchBar';

import styles from './Header.module.scss';

const HeaderMobile = ({
    navigation,
    popularSearches,
    showIntro,
    onSearchIsOpen,
    onMenuOpenChange,
    onMobileSearchOpenChange,
    onBackFromSearchPanelChange,
}) => {
    const overlayRef = useRef();

    const items = navigation.itemsCollection.items;
    const splitIdx = Math.ceil(items.length / 2);
    const linksLeft = items.slice(0, splitIdx);
    const linksRight = items.slice(splitIdx, items.length);

    const [menuOpen, setMenuOpen] = useState(false);
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const [subSubMenuOpen, setSubSubMenuOpen] = useState(false);
    const [backFromSubPanel, setBackFromSubPanel] = useState(false);
    const [backFromSubSubPanel, setBackFromSubSubPanel] = useState(false);
    const [backFromSearchPanel, setBackFromSearchPanel] = useState(false);
    const [subMenuData, setSubMenuData] = useState(false);
    const [subSubMenuData, setSubSubMenuData] = useState(false);
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

    const pathname = usePathname();

    // Reset on navigation
    useEffect(() => {
        setMenuOpen(false);
        setSubMenuOpen(false);
        setSubSubMenuOpen(false);
        setBackFromSubPanel(false);
        setBackFromSubSubPanel(false);
        setBackFromSearchPanel(false);
        setIsMobileSearchOpen(false);
    }, [pathname]);

    // Bubble state changes to parent for header container classes
    useEffect(() => {
        onMenuOpenChange?.(menuOpen);
    }, [menuOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        onMobileSearchOpenChange?.(isMobileSearchOpen);
    }, [isMobileSearchOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        onBackFromSearchPanelChange?.(backFromSearchPanel);
    }, [backFromSearchPanel]); // eslint-disable-line react-hooks/exhaustive-deps

    // Body scroll lock
    useEffect(() => {
        const target = overlayRef.current;
        if (!target) return;

        if (menuOpen) {
            disableBodyScroll(target, {
                allowTouchMove: () => overlayRef.current,
            });
        } else {
            enableBodyScroll(target);
        }

        return () => {
            enableBodyScroll(target);
        };
    }, [menuOpen]);

    const handleClickItem = item => {
        setSubMenuData(item);
        setSubMenuOpen(true);
    };

    const handleBackClick = () => {
        if (subSubMenuOpen) {
            setBackFromSubSubPanel(true);
            setSubSubMenuOpen(false);
            return;
        }
        setBackFromSubPanel(true);
        setBackFromSearchPanel(false);
        setSubMenuOpen(false);
        setSubSubMenuOpen(false);
        setIsMobileSearchOpen(false);
    };

    const handleSubGroupClick = groupItem => {
        setSubSubMenuData(groupItem);
        setSubSubMenuOpen(true);
        setBackFromSubSubPanel(false);
    };

    const handleSearchIsOpen = isOpen => {
        onSearchIsOpen?.(isOpen);
    };

    const handleLogoClick = e => {
        if (pathname === '/' && !menuOpen) {
            e.preventDefault();
            window.scrollTo({ top: 0 });
        }
    };

    const renderLinks = (items, navId) =>
        items.map((item, i) => {
            const hasSubItems =
                item.link.__typename === 'ManualLink' &&
                item?.itemsCollection.items.length > 0;
            const delay = (navId == 'left' ? i : i + 4) * 60;
            return (
                <li
                    key={i}
                    style={{ '--delay': `${delay}ms` }}
                    className={cx(styles.navItem, {
                        [styles.hasChevron]: hasSubItems,
                        [styles.hasArrow]:
                            item.link.__typename === 'ExternalLink',
                    })}
                >
                    {hasSubItems ? (
                        <button
                            onClick={() => handleClickItem(item)}
                            className={styles.linkSmall}
                        >
                            <span className={styles.linkInner}>
                                {item.linkTitle}
                            </span>
                        </button>
                    ) : (
                        <EntryLink
                            entry={item.link}
                            className={styles.linkSmall}
                        >
                            <span className={styles.linkInner}>
                                {item.linkTitle}
                            </span>
                        </EntryLink>
                    )}
                </li>
            );
        });

    return (
        <>
            <div
                className={cx(styles.mobileLogoWrapper, {
                    [styles['mobileLogoWrapper--open']]: menuOpen,
                    [styles['mobileLogoWrapper--subPanelOpen']]: subMenuOpen,
                    [styles['mobileLogoWrapper--backFromSubPanel']]:
                        backFromSubPanel,
                })}
            >
                <Link
                    href="/"
                    aria-label="Home"
                    title="Home"
                    onClick={handleLogoClick}
                >
                    <Logo withMorningStar className={styles.logoSvg} />
                    <span className="sr-only">Home</span>
                </Link>
            </div>
            <div className={styles.mobileRoot}>
                <nav
                    ref={overlayRef}
                    role="navigation"
                    aria-label="Main menu"
                    data-overlay={true}
                    aria-hidden={!menuOpen}
                    inert={!menuOpen ? true : undefined}
                    className={cx(styles.nav, {
                        [styles['nav--open']]: menuOpen,
                        [styles['nav--subPanelOpen']]: subMenuOpen,
                        [styles['nav--subSubPanelOpen']]: subSubMenuOpen,
                    })}
                >
                    <div
                        className={cx(styles.mobileLogoWrapperTop, {
                            [styles['mobileLogoWrapperTop--open']]: menuOpen,
                            [styles['mobileLogoWrapperTop--subPanelOpen']]:
                                subMenuOpen,
                            [styles['mobileLogoWrapperTop--backFromSubPanel']]:
                                backFromSubPanel,
                        })}
                    >
                        <Link href="/" aria-label="Home" title="Home">
                            <Logo withMorningStar className={styles.logoSvg} />
                        </Link>
                    </div>
                    <div
                        className={cx(styles.mobileSubPanel, {
                            [styles['mobileSubPanel--subSubOpen']]:
                                subSubMenuOpen,
                            [styles['mobileSubPanel--backFromSubSub']]:
                                backFromSubSubPanel,
                        })}
                    >
                        <button
                            className={cx(styles.navItem, styles.back)}
                            onClick={handleBackClick}
                        >
                            Back
                        </button>
                        {subMenuData?.itemsCollection?.items?.length > 0 && (
                            <nav className={styles.mobileSubPanelNav}>
                                <SubNavItems
                                    items={subMenuData.itemsCollection.items}
                                    headingLink={subMenuData.link}
                                    headingTitle={subMenuData.subMenuTitle}
                                    onGroupClick={subItem =>
                                        handleSubGroupClick(subItem)
                                    }
                                />
                            </nav>
                        )}
                    </div>
                    <div
                        className={cx(styles.mobileSubSubPanel, {
                            [styles['mobileSubSubPanel--open']]: subSubMenuOpen,
                            [styles['mobileSubSubPanel--back']]:
                                backFromSubSubPanel,
                        })}
                    >
                        <button
                            className={cx(styles.navItem, styles.back)}
                            onClick={handleBackClick}
                        >
                            {subMenuData?.linkTitle || 'Back'}
                        </button>
                        {subSubMenuData?.itemsCollection?.items?.length > 0 && (
                            <nav className={styles.mobileSubPanelNav}>
                                <SubNavGroupItems group={subSubMenuData} />
                            </nav>
                        )}
                    </div>
                    <section className={styles.inner}>
                        <button
                            className={cx(
                                styles.mobileSearchBarBack,
                                styles.back
                            )}
                            onClick={() => {
                                setIsMobileSearchOpen(false);
                                setBackFromSearchPanel(true);
                            }}
                        >
                            Back
                        </button>
                        <div className={styles.linksWrapper}>
                            <div className={styles.searchBarMobile}>
                                <SearchBar
                                    className={styles.mobileSearchBar}
                                    onIsOpen={handleSearchIsOpen}
                                    onSubmitted={() => {
                                        setMenuOpen(false);
                                        setBackFromSubPanel(false);
                                        setBackFromSearchPanel(false);
                                        setIsMobileSearchOpen(false);
                                    }}
                                    onClick={() => {
                                        setIsMobileSearchOpen(true);
                                        setBackFromSubPanel(false);
                                        setBackFromSearchPanel(false);
                                    }}
                                    isActive={isMobileSearchOpen}
                                    popularSearches={popularSearches}
                                />
                            </div>
                            <ul className={styles.leftLinks}>
                                {renderLinks(linksLeft, 'left')}
                            </ul>
                            <ul className={styles.rightLinks}>
                                {renderLinks(linksRight, 'right')}
                            </ul>
                        </div>
                    </section>
                </nav>
                <CheeseburgerButton
                    onClick={() => {
                        const open = !menuOpen;
                        setMenuOpen(open);
                        setIsMobileSearchOpen(false);
                        setBackFromSubPanel(false);
                        setBackFromSubSubPanel(false);
                        setBackFromSearchPanel(false);
                        if (!open) {
                            setSubMenuOpen(false);
                            setSubSubMenuOpen(false);
                        }
                    }}
                    showIntro={showIntro}
                    menuVisible={menuOpen}
                />
            </div>
        </>
    );
};

export default HeaderMobile;
